
<div class="card card-statistics mb-30" >
  <div class="card-body">
    <h5 class="card-title">فرم اطلاعات مرخصی روزانه</h5>
    <form>


      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> تاریخ شروع </label>
          <input disabled type="text" value="{{startDate_fulldate}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> تاریخ پایان </label>
          <input disabled type="text" value="{{endDate_fulldate}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> جایگزین </label>
          <input disabled type="text" value="{{replace_person}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> روز کاری </label>
          <input disabled type="text" value="{{on}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> روز تعطیل </label>
          <input disabled type="text" value="{{off}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> شرح </label>
          <input disabled type="text" value="{{dsc}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>
    </form>
  </div>
</div>